import { cn } from "@/lib/utils";
import { Badge } from "@/components/ui";
import { badgeVariantFromConfig } from "@/lib/statusBadgeFromConfig";
import {
  STATUS_CONFIG,
  PRIORITY_CONFIG,
  CATEGORY_CONFIG,
  ticketStatusLabel,
  ticketPriorityLabel,
  ticketCategoryLabel,
  type TicketStatus,
  type TicketPriority,
  type TicketCategory,
} from "./config";

interface TicketStatusBadgeProps {
  status: TicketStatus;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export function TicketStatusBadge({
  status,
  size = "md",
  className,
}: TicketStatusBadgeProps) {
  const config = STATUS_CONFIG[status];
  const Icon = config.icon;

  return (
    <Badge
      variant={badgeVariantFromConfig(status, STATUS_CONFIG)}
      size={size}
      className={cn("whitespace-nowrap", className)}
    >
      <Icon />
      {ticketStatusLabel(status)}
    </Badge>
  );
}

interface TicketPriorityBadgeProps {
  priority: TicketPriority;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export function TicketPriorityBadge({
  priority,
  size = "md",
  className,
}: TicketPriorityBadgeProps) {
  const config = PRIORITY_CONFIG[priority];
  const Icon = config.icon;

  return (
    <Badge
      variant={badgeVariantFromConfig(priority, PRIORITY_CONFIG)}
      size={size}
      className={cn("whitespace-nowrap", className)}
    >
      <Icon />
      {ticketPriorityLabel(priority)}
    </Badge>
  );
}

interface TicketCategoryBadgeProps {
  category: TicketCategory;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export function TicketCategoryBadge({
  category,
  size = "md",
  className,
}: TicketCategoryBadgeProps) {
  const config = CATEGORY_CONFIG[category];

  return (
    <Badge
      variant="outline"
      size={size}
      className={cn("whitespace-nowrap", className)}
    >
      <span className="inline-flex size-[1em] items-center justify-center leading-none">
        {config.emoji}
      </span>
      {ticketCategoryLabel(category)}
    </Badge>
  );
}
